{
	"content": {
		"title": "Sélectionnez les matériaux nécessitant des déclarations",
		"materialListLabel": "Matériau",
		"materialQuantityLabel": "Quantité de matériau ({{unit}})",
		"availableQuantityLabel": "Quantité disponible ({{unit}})",
		"carbonSavingsLabel": "Réductions de carbone ({{unit}} éq. CO₂)"
	},
	"summary": {
		"title": "Récapitulatif",
		"declarationTypeTitle": "Type de déclaration",
		"customerProjectTitle": "Projet client",
		"internalProjectOrProductTitle": "Projet / produit interne",
		"projectReferenceTitle": "Référence du projet",
		"materialHeaderTitle": "Matériau",
		"quantityHeaderTitle": "Quantité ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Réductions de carbone allouables ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Réduction de carbone non allouable ({{unit}})"
	},
	"errorMessages": {
		"quantityRequired": "La quantité est requise",
		"quantityPositive": "Veuillez saisir une quantité positive.",
		"quantityLargerThanAvailable": "Veuillez réduire la quantité au total disponible",
		"savingsRequired": "Les réductions de carbone sont requises",
		"fetchNotTransferedMaterialsError": "Échec de la récupération des matériaux non transférés"
	},
	"submitTitle": "Ajouter au projet",
	"backTitle": "Retour"
}
